<template>
  <a
    v-if="isDisabled"
    :class="classList"
    v-bind="attributes"
    tabindex="-1"
    @click.stop.prevent
  >
    <AppIcon :name="icon" class="nav-icon" inherit-size />
    <span>{{ name }}</span>
    <b-badge v-if="badge && badge.text" :variant="badge.variant">{{ badge.text }}</b-badge>
  </a>
  <a
    v-else-if="isExternalLink"
    :href="url"
    :class="classList"
    v-bind="attributes"
  >
    <AppIcon :name="icon" class="nav-icon" inherit-size />
    <span>{{ name }}</span>
    <b-badge v-if="badge && badge.text" :variant="badge.variant">{{ badge.text }}</b-badge>
  </a>
  <router-link
    v-else
    :to="url"
    :class="classList"
    v-bind="attributes"
  >
    <AppIcon :name="icon" class="nav-icon" inherit-size />
    <span>{{ name }}</span>
    <b-badge v-if="badge && badge.text" :variant="badge.variant">{{ badge.text }}</b-badge>
  </router-link>
</template>

<script>
export default {
  name: 'AppSidebarNavLink',
  props: {
    name: { type: String, default: '' },
    url: { type: String, default: '' },
    icon: { type: String, default: '' },
    badge: { type: Object, default: () => ({}) },
    variant: { type: String, default: '' },
    classes: { type: [String, Array, Object], default: '' },
    attributes: {
      type: Object,
      default: () => Object.create(null),
    },
  },
  computed: {
    classList() {
      return [
        'nav-link',
        this.linkVariant,
        ...this.disabledClasses,
        ...this.attrClasses,
        ...this.itemClasses,
      ]
    },
    linkVariant() {
      return this.variant ? `nav-link-${this.variant}` : ''
    },
    itemClasses() {
      return this.getClassArray(this.classes)
    },
    attrClasses() {
      return this.getClassArray(this.attributes.class)
    },
    disabledClasses() {
      return this.isDisabled ? ['disabled'] : []
    },
    isDisabled() {
      return Boolean(this.attributes.disabled)
    },
    isExternalLink() {
      return this.url.substring(0, 4) === 'http'
    },
  },
  methods: {
    getClassArray(classes) {
      if(!classes) return []
      if(typeof classes === 'string' || classes instanceof String) return classes.split(' ')
      if(Array.isArray(classes)) return classes
      return Object.keys(classes).filter(key => classes[key])
    },
  },
}
</script>
